module.exports = __webpack_public_path__ + "img/saddle-cloths-13.80c845fd.svg";